import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { User } from "./authSlice";

interface DecodedToken extends User {
  exp: number;
  iat: number;
}

const getEmptyUserState = (): User => ({
  _id: "",
  email: "",
  userType: "",
  userVerified: false,
  subscriptionStatus: "",
  firstName: "",
  lastName: "",
  avatar: "",
});

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    if (!decoded.exp) return false; // No expiration claim
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const getInitialUserState = (): User => {
  const token = Cookies.get("token");

  if (!token) {
    return getEmptyUserState();
  }

  // Check if token is expired
  if (isTokenExpired(token)) {
    Cookies.remove("token");
    return getEmptyUserState();
  }

  try {
    const decodedToken = jwtDecode<DecodedToken>(token);
    return {
      _id: decodedToken._id,
      email: decodedToken.email,
      userType: decodedToken.userType || "",
      userVerified: decodedToken.userVerified || false,
      firstName: "",
      lastName: "",
      avatar: "",
    };
  } catch (error) {
    console.error("Failed to decode token:", error);
    Cookies.remove("token");
    return getEmptyUserState();
  }
};
